import * as React from 'react';
import { useAuthState } from 'react-firebase-hooks/auth';
import { Button } from 'reactstrap';
import { logger, serverLogger } from '../logging';
import {
  getDAMApp,
  getCanopusApp,
  getIFBApp,
  getPartyServiceApp,
  getAddressbooksApp,
} from '../services/firebase';
import { getAuth, signOut } from 'firebase/auth';

type LogoutButtonProps = {
  inBanner?: boolean;
  bannerClassName?: string;
};

export const LogoutButton = ({
  inBanner = false,
  bannerClassName,
}: LogoutButtonProps) => {
  const damApp = getDAMApp();
  const ifbApp = getIFBApp();
  const canopusApp = getCanopusApp();
  const partyServiceApp = getPartyServiceApp();
  const addressbooksApp = getAddressbooksApp();
  const damAuth = getAuth(damApp);
  const canopusAuth = getAuth(canopusApp);
  const ifbAuth = getAuth(ifbApp);
  const partyServieAuth = getAuth(partyServiceApp);
  const addressbooksAuth = getAuth(addressbooksApp);

  const [user] = useAuthState(damAuth as any);

  const logout = () => {
    if (user) {
      const userEmail = user['email'];
      // logger.info('reidrecting to', from.pathname);
      try {
        serverLogger(`User logged out: ${userEmail}`, 'info');
      } catch (e) {
        logger.error('error calling serverlogger');
      }
    }

    signOut(damAuth);
    signOut(canopusAuth);
    signOut(ifbAuth);
    signOut(partyServieAuth);
    signOut(addressbooksAuth);
  };

  if (user) {
    if (inBanner) {
      return (
        <Button
          color="link"
          className={`p-0 ${bannerClassName ?? ''}`.trim()}
          onClick={logout}
        >
          Log Out ({user.email})
        </Button>
      );
    }

    return <Button onClick={logout}>Log Out ({user.email})</Button>;
  }

  return <div></div>;
};
